import axios from 'axios';

const s3Client = axios.create({
  timeout: 120000,
});

export default s3Client;
